export default __webpack_public_path__ + "static/media/CFFundBannerMobile.e63b8b64.png";